import { RestError } from "../../services/rest-service/RestService";
import { useMutation, useQueryClient } from "react-query";
import { INotificationMessageModel } from "../../services/notification-message-service/Models";
import NotificationMessageDataService from "../../services/notification-message-service/NotificationMessageService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { MutationContextType } from "./Common";
import { keys } from "./Keys";

export type UseSaveNotificationMessageParameters = {
    groupID: number,
} & BaseUseMutationParameters<void, INotificationMessageModel>;

export function useSaveNotificationMessage({
    groupID,
    onError,
    onSuccess
}: UseSaveNotificationMessageParameters) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, INotificationMessageModel, MutationContextType>(
        (model) => {
            return NotificationMessageDataService.acknowledgeMessage(groupID, model.id);
        },
        {
            onMutate: async (item: INotificationMessageModel) => {

                await queryClient.cancelQueries(keys.all);

                const previousItems = queryClient.getQueryData<INotificationMessageModel[]>(
                    keys.list(
                        groupID
                    )
                );

                queryClient.setQueryData<INotificationMessageModel[]>(
                    keys.list(
                        groupID
                    ),
                    (old?: INotificationMessageModel[]) => {
                        const existing = old?.find(o => o.id === item.id);

                        return existing
                            ? old?.map(o => (o.id === item.id ? item : o)) ?? []
                            : [...(old ?? []), item];
                    }
                );

                return {
                    previousItems
                };
            },
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, error, _runTicket, context) => {

                if (error && context?.previousItems) {
                    queryClient.setQueryData<INotificationMessageModel[]>(
                        keys.list(
                            groupID
                        ),
                        context?.previousItems
                    );
                }

                queryClient.invalidateQueries(keys.lists());
            }
        }
    );
}
